import HubBase from '../HubBase.ts';
import { API_URL } from '../../lib/config.ts';

export interface SystemMessageCallbacks {
  onDeploymentNotification: (message: string) => void;
  onGeneralMessage: (message: string) => void;
}

class SystemMessageHub extends HubBase {
  private callbacks: SystemMessageCallbacks;

  constructor(callbacks: SystemMessageCallbacks) {
    super(`${API_URL}/hubs/SystemMessage`);
    this.callbacks = callbacks;
    this.setupHub();
  }

  public start = async () => {
    await this.startConnection();
  };

  private setupHub = () => {
    this.connection.on('ReceiveDeploymentNotification', (message: string) => {
      this.callbacks.onDeploymentNotification(message);
    });

    this.connection.on('ReceiveGeneralMessage', (message: string) => {
      this.callbacks.onGeneralMessage(message);
    });
  };
}

export default SystemMessageHub;
